<template>
  <div class="HairBuyerDialog">
    <el-dialog
      :center="true"
      @close="tableVisible = false"
      :visible="tableVisible"
      :title="title"
      width="90%"
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <el-button @click="onHandleBuyer" :disabled="!supplier_ids.length"
          >数据迁移</el-button
        >
        <div style="display: flex; align-items: center">
          <div class="inputs mr10">
            <el-select
              v-model="formChildData.search_first_cid"
              @change="selectchange"
              filterable
              clearable 
              placeholder="请选择一级品类"
            >
              <el-option
                v-for="item in options1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="inputs mr10">
            <el-select
              v-model="formChildData.search_second_cid"
              @change="selectchange2"
              filterable
              clearable 
              placeholder="请选择二级品类"
            >
              <el-option
                v-for="item in options2"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="inputs mr10">
            <el-select
              v-model="formChildData.search_category_tag_id"
              filterable
              clearable 
              placeholder="请选择三级品类"
            >
              <el-option
                v-for="item in options3"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="inputs mr10">
            <el-input
              v-model="formChildData.search_supplier_name"
              placeholder="请输入供应商名称"
              clearable
            ></el-input>
          </div>
          <el-button
            @click="searchSupplier"
            type="primary"
            icon="el-icon-search"
            >查询</el-button
          >
        </div>
      </div>

      <div class="row-box d-flex flex-column mt-20 height-500">
        <el-table
          :data="listData"
          height="100%"
          :border="true"
          :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
           
            align="center"
            label="序号"
          >
          </el-table-column>
          <el-table-column
            prop="supplierName"
            align="center"
           
            label="供货商名称"
          >
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.supplierName) }}
            </template>
          </el-table-column>
          <el-table-column  prop="firstCategoryName"  align="center" label="品类名称">
            <template slot-scope="scope">
              {{ scope.row.firstCategoryName }}—{{ scope.row.categoryName }}—{{ scope.row.categoryTagName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="categoryIsAudit"
            align="center"
            label="品类是否需要审核"
            width="70"
          >
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.categoryIsAudit) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isBuyer"
            align="center"
            width="70"
            label="是否是买手"
          >
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.isBuyer) }}
            </template>
          </el-table-column>
          <el-table-column prop="onsaleCount"  width="70" align="center" label="在售中的商品">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.onsaleCount) }}
            </template>
          </el-table-column>
          <el-table-column prop="offlineCount" width="70" align="center" label="下架及审核中的商品">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.offlineCount) }}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="onHandleBuyer(scope.row)"
                >迁移</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination-position">
          <el-pagination
            type="primary"
            background
            @size-change="handleBuyerChange"
            @current-change="handleBuyerCurrentChange"
            :current-page="currentlistPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="formChildData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listtotal"
          >
          </el-pagination>
        </div>
      </div>
      <template #footer>
        <el-button @click="tableVisible = false">返回</el-button>
      </template>
    </el-dialog>

    <el-dialog
      title="全部迁移"
      :visible.sync="buyerDialogVisible"
      v-if="buyerDialogVisible"
      width="40%"
      class="dialog"
      center
    >
      <div class="content">
        <el-select
          v-model="buyer_id_new"
          placeholder="请选择数据将要迁移到的业务员姓名"
          filterable
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.fullname + '(' + item.mobile + ')'"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div style="color: red; margin-top: 20px">
          在售、审核中、下架的商品均迁移到新的业务；新迁移的业务需先配置该品类【基采业务-负责品类】，且为同一角色（比如买手，才可迁移）
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="buyerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onHandleChose">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: "HairBuyerDialog",
  props: {},
  data() {
    return {
      tableVisible: false,
      title: "",
      supplier_ids: [],
      buyerDialogVisible: false,
      options1: [],
      options2: [],
      options3: [],
      formChildData: {
        buyer_id: "",
        search_supplier_name: "",
        search_first_cid: "", //	number	筛选项 - 一级分类id
        search_second_cid: "", //	number	筛选项 - 二级分类id
        search_category_tag_id: "", //	number	筛选项 - 三级分类id
        page: 1,
        pageSize: 10,
      }, // 新增业务表单
      listData: [],
      currentlistPage: 1,
      listtotal: 0,
      buyer_id: "",
      buyer_id_new: "",
      options: [],
    };
  },
  computed: {},
  methods: {
    selectchange(e) {
      console.log(e);
      this.formChildData.search_second_cid='';
      this.options2=[];
      this.formChildData.search_category_tag_id='';
      this.options3=[];
      this.options1.forEach((el) => {
        if (el.id == e) {
          this.options2 = el.secondCategory;
          return;
        }
      });
    },
    selectchange2(e) {
      this.formChildData.search_category_tag_id='';
      this.options3=[];
      this.options2.forEach((el) => {
        if (el.id == e) {
          this.options3 = el.tags;
          return;
        }
      });
    },
    hqlist() {
      this.$api.general.searchcategorieslist().then((res) => {
        console.log(res, "1111111111111");
        this.options1 = res.data;
      });
    },
    hqinfo(e) {
      this.hqlist();
      this.title = "迁移发品供应商";
      this.listData = [];
      this.supplier_ids = [];
      console.log('查看选中是否有数据',this.supplier_ids);
      Object.assign(this.$data.formChildData, this.$options.data().formChildData);
      this.formChildData.buyer_id = this.buyer_id = e.id;
      // this.buyer_id_new = e.id;//默认不显示
      // 重置分页参数
      this.formChildData.page = 1;
      this.formChildData.pageSize = 10;
      this.buyerSupplierList();
      this.tableVisible = true;
    },
    /**
     * 数据迁移确认
     */
    onHandleChose() {
      // console.log(this.buyer_id, this.supplier_ids);
      if (this.buyer_id_new) {
        let request_data = [];
        this.supplier_ids.forEach((el) => {
          request_data.push({
            ...el,
            buyer_id: this.buyer_id,
            new_buyer_id: this.buyer_id_new,
          });
        });

        this.tool.debounce(() => {
          this.$api.general
            .bindsupplierproduct({ request_data: request_data })
            .then((res) => {
              this.$message({
                type: "success",
                message: "迁移成功",
              });
              this.buyerDialogVisible = false;
              // this.tableVisible = false;
              this.buyerSupplierList();
              this.$emit("successDialog", true);
            });
        });
      } else {
        this.$message({
          type: "error",
          message: "请选择业务员",
        });
      }
    },
    /**
     * 数据迁移勾选成员
     */
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.supplier_ids = [];
      console.log(val);
      val.forEach((item) => {
        this.supplier_ids.push({
          supplier_id: item.supplierId,
          cid: item.categoryId,
          category_tag_id: item.categoryTagId,
        });
      });
    },
    /**
     * 触发数据迁移按钮
     */
    onHandleBuyer(row) {
      this.buyerDialogVisible = true;
   
      if (row?.supplierId) {
        this.supplier_ids = [];
        this.supplier_ids.push({
          supplier_id: row.supplierId,
          cid: row.categoryId,
          category_tag_id: row.categoryTagId,
        });
      }
      this.getAjaxBuyerList();
    },
    /**
     * 获取业务人员列表
     */
    async getAjaxBuyerList() {
    let cidarr =JSON.parse(JSON.stringify(this.supplier_ids))
      const params = {
        buyer_id: this.buyer_id,
        type: 2, //1: 绑定供应商 2: 发品供应商
        cid_list:cidarr.map(el=>el.cid)
      };
      try {
        const { data } = await this.$api.general.movebuyerlist(params);
        this.options = data;
        this.buyer_id_new =data.length>0? data[0].id:'';
      } catch (err) {
        console.log("ajax getAjaxBuyerList err", err);
      }
    },
    buyerSupplierList() {
      this.$api.general
        .bindsupplierproductList(this.formChildData)
        .then((res) => {
          console.log(res, "获取数据");
          this.listData = res.data.data;
          this.listtotal = res.data.total;
        });
    },
    searchSupplier() {
      this.formChildData.page = 1;
      this.currentlistPage = 1;
      this.buyerSupplierList();
    },
    handleBuyerChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.formChildData.pageSize = val;
      this.buyerSupplierList();
    },
    handleBuyerCurrentChange(val) {
      this.formChildData.page = val;
      this.currentlistPage = val;
      this.buyerSupplierList();
    },
  },
};
</script>

<style lang="scss" scoped>
.HairBuyerDialog {
  .height-500 {
    height: 800px;
  }
 /deep/ .el-dialog {
    margin-top: 0vh !important;
  }
  .pagination-position {
    margin-top: 20px;
  }
}
</style>
